import { render, staticRenderFns } from "./LpuDocuments.vue?vue&type=template&id=4e4ff812&"
import script from "./LpuDocuments.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuDocuments.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e4ff812')) {
      api.createRecord('4e4ff812', component.options)
    } else {
      api.reload('4e4ff812', component.options)
    }
    module.hot.accept("./LpuDocuments.vue?vue&type=template&id=4e4ff812&", function () {
      api.rerender('4e4ff812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDocuments/LpuDocuments.vue"
export default component.exports